export type ChartBoxSize = { width: number; height: number };

const EMPTY: ChartBoxSize = { width: 0, height: 0 };

/**
 * Pick a new pixel size for the dashboard chart, or null to keep the previous one.
 * Ignores sub-pixel / 1px ResizeObserver chatter that otherwise remounts Recharts
 * axes in a setState loop (Sentry MEISTERPLATFORM-FRONTEND-B / G).
 */
export function nextStableChartBoxSize(
  prev: ChartBoxSize | null | undefined,
  width: number,
  height: number,
  minDelta = 1,
): ChartBoxSize | null {
  const next = { width: Math.round(width), height: Math.round(height) };
  if (next.width < 1 || next.height < 1) return null;
  const current = prev ?? EMPTY;
  if (
    Math.abs(current.width - next.width) <= minDelta &&
    Math.abs(current.height - next.height) <= minDelta
  ) {
    return null;
  }
  return next;
}
